import React from 'react';
import { useCadastroProducao } from '../../../hook/useCadastroProducao';
import { Row } from 'react-bootstrap';
import Tippy from '@tippyjs/react';
import { DataGrid, GridColDef } from '@material-ui/data-grid';
import {
  formatCurrencyAsTex3,
  formatCurrencyAsText,
  transformAsCurrency,
} from '~/utils/functions';
import { FaTrash } from 'react-icons/fa';
import { GoPencil } from 'react-icons/go';
import { deleteItens, insertOrUpdate } from '~/utils/masterDetail';
import { ButtonRow, TableContainer } from './style';
import { calculaSubTotal } from '../../../functions/calcSubTotal';
import { useHandleFocus } from '~/pages/CadastroDePoducao/hook/useHandleFocus';
import { calcUnitario } from '~/pages/CadastroDePoducao/functions/calcUnit';

export const TableProdutos: React.FC = () => {
  const {
    setUpdateItem,
    produtosRows,
    masterDetail,
    setMasterDetail,
    setProdutosRows,
    setProdutoIdUpdate,
    formProducao,
    setProdutoAtual,
    setProdutoAtualReset,
    setQtdRendeKg,
    setQtdTotProducao,
    setQtdTotReceita,
    setCustoSemImposto,
    setValCustoFinal,
    setValCustoReceita,
    setValCustoProducao,
  } = useCadastroProducao();
  const { setValue, getValues } = formProducao;
  const { handleInputFocus } = useHandleFocus();

  const columns: GridColDef[] = [
    {
      field: 'id',
      headerName: 'Id',
      hide: true,
      width: 100,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: 'cod_loja',
      headerName: 'Loja',
      width: 40,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params: { row: any }) => {
        const { row } = params;
        return (
          <>
            <span>{row.cod_loja}</span>
          </>
        );
      },
    },
    {
      field: 'cod_produto',
      headerName: 'Código',
      width: 150,
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params: { row: any }) => {
        const { row } = params;
        return (
          <>
            <span>{row.cod_produto}</span>
          </>
        );
      },
    },
    {
      field: 'des_produto',
      headerName: 'Descrição',
      width: 350,
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params: { row: any }) => {
        const { row } = params;
        return (
          <Tippy
            content={row.des_produto}
            arrow
            placement="bottom"
            animation="scale"
          >
            <div className="text-truncate" style={{ width: '320px' }}>
              <span>{row.des_produto}</span>
            </div>
          </Tippy>
        );
      },
    },
    {
      field: 'val_custo_rep',
      headerName: 'Custo Rep.',
      flex: 1,
      width: 150,
      sortable: false,
      disableColumnMenu: true,
      align: 'right',
      renderCell: (params: { row: any }) => {
        const { row } = params;
        return (
          <>
            <span>{formatCurrencyAsText(row.val_custo_rep || 0)}</span>
          </>
        );
      },
    },
    {
      field: 'qtd_receita',
      headerName: 'Qtd. Receita',
      width: 170,
      flex: 1,
      disableColumnMenu: true,
      sortable: false,
      align: 'right',
      renderCell: (params: { row: any }) => {
        const { row } = params;
        return (
          <>
            <span>{formatCurrencyAsTex3(row.qtd_receita)}</span>
          </>
        );
      },
    },
    {
      field: 'qtd_producao',
      headerName: 'Qtd. Produção',
      flex: 1,
      width: 220,
      disableColumnMenu: true,
      sortable: false,
      align: 'right',
      renderCell: (params: { row: any }) => {
        const { row } = params;
        return (
          <>
            <span>{formatCurrencyAsTex3(row.qtd_producao)}</span>
          </>
        );
      },
    },
    {
      field: 'acoes',
      headerName: 'Ações',
      width: 130,
      sortable: false,
      disableColumnMenu: true,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: { row: any }) => {
        const { row } = params;
        return (
          <>
            <ButtonRow
              type="button"
              onClick={() => onEditItem(row)}
              isBlocked={false}
              disabled={false}
              title="Editar"
            >
              <GoPencil size={20} style={{ color: '#72ab90' }} />
            </ButtonRow>
            <ButtonRow
              type="button"
              onClick={() => onRemoveItem(row)}
              isBlocked={false}
              disabled={false}
              title="Excluir"
            >
              <FaTrash size={20} style={{ color: '#e63c3c' }} />
            </ButtonRow>
          </>
        );
      },
    },
  ];
  const onEditItem = async (value: any) => {
    setValue('busca_produto', {
      label: `${value.cod_produto} - ${value.des_produto}`,
      value: value.cod_produto_composicao,
    });
    setValue('qtd_receita', formatCurrencyAsTex3(value.qtd_receita));
    setProdutoAtual(value);
    setProdutoIdUpdate(value.uuid);
    handleInputFocus('qtd_receita');
    setUpdateItem(true);
  };

  const onRemoveItem = async (data: any) => {
    const { per_despesa_producao, qtd_rendimento } = getValues();
    const updateRow: any = deleteItens(
      'produtos',
      data.uuid,
      masterDetail,
      setMasterDetail,
    );
    setProdutosRows(updateRow);
    const totalQtdReceita = updateRow.reduce((total: number, item: any) => {
      return total + transformAsCurrency(item.qtd_receita);
    }, 0);

    const updatedRows = updateRow.map((item: any) => {
      const { uuid, id } = item;
      const itemQtdReceita = transformAsCurrency(item.qtd_receita);

      const resultCalcUnit = calcUnitario({
        produtoAtual: item,
        qtdReceita: itemQtdReceita,
        totQtdReceita: totalQtdReceita,
        qtdRendimento: transformAsCurrency(qtd_rendimento),
      });

      return {
        ...item,
        uuid,
        id,
        qtd_producao: resultCalcUnit.qtdProducao,
        qtd_rendimento: resultCalcUnit.qtdRendeKg,
        custoSemImpostoFinal: resultCalcUnit.custoSemImpostoFinal,
        custoFinal: resultCalcUnit.custoFinal,
      };
    });

    const masterUpdated = await updatedRows.reduce(
      async (previousPromise: any, updatedRow: any) => {
        const masterDetailCurrent = await previousPromise;

        return insertOrUpdate(
          'produtos',
          updatedRow,
          masterDetailCurrent,
          setMasterDetail,
        );
      },
      Promise.resolve(masterDetail),
    );
    setTimeout(() => {
      setProdutosRows(updatedRows);
    }, 100);

    const resultadoCalcSubTotal = calculaSubTotal({
      itens: updatedRows,
      perDespesaProducao: transformAsCurrency(per_despesa_producao),
    });
    setQtdRendeKg(resultadoCalcSubTotal.rendeKg);
    setQtdTotProducao(resultadoCalcSubTotal.totQtdProducao);
    setQtdTotReceita(resultadoCalcSubTotal.totQtdReceita);
    setCustoSemImposto(resultadoCalcSubTotal.custoSemImp);
    setValCustoFinal(resultadoCalcSubTotal.custoFinalProducao);
    setValCustoReceita(resultadoCalcSubTotal.custoReceita);
    setValCustoProducao(resultadoCalcSubTotal.custoProducao);

    setProdutoAtualReset();
    handleInputFocus('busca_produto');
    setValue('qtd_receita', '');
    setUpdateItem(false);
    return setValue('busca_produto', '');
  };

  return (
    <Row>
      <TableContainer>
        <DataGrid
          rowsPerPageOptions={[5]}
          rows={produtosRows}
          columns={columns}
          pageSize={5}
          autoHeight
          disableColumnSelector
          disableColumnFilter
          disableSelectionOnClick
          localeText={{
            noRowsLabel: 'Nenhum registro encontrado...',
            columnMenuLabel: 'Menu',
            columnMenuFilter: 'Filtrar',
            columnMenuHideColumn: 'Esconder',
            columnMenuUnsort: 'Não ordenar',
            columnMenuSortAsc: 'Ordernar ASC',
            columnMenuSortDesc: 'Ordernar DESC',
            columnMenuShowColumns: 'Mostrar columnas',
          }}
        />
      </TableContainer>
    </Row>
  );
};
